import React from 'react';

const tooltipStyle = {
  backgroundColor: '#F2F2F2',
  marginTop: '-1rem',
  padding: '0.5rem',
  fontSize: '12px'
};

function RebrandTooltip({ text, additionalStyle = {} }) {
  return (
    <div css={[tooltipStyle, additionalStyle]}>
      <span>{text}</span>
    </div>
  );
}

export default RebrandTooltip;
